<script>
  import { scaleLinear } from "d3-scale";
  import { timeFormat } from "d3-time-format";
  import { range } from "d3-array";
  import { line as d3line, curveBasis } from "d3-shape";

  export let isMobile = true;

  export let data = {
    cases: [],
    min: 0,
    max: 0,
    pctChangeCases: 0,
    pctChangeDeath: 0,
    r: 0,
    rConfidence: 0,
  };

  $: cases = data.cases.map((d) => ({ ...d, d: new Date(d.d) }));
  $: lastDatum = cases[cases.length - 1];
  $: lastAll7DSumCaseAve = data.lastAll7DSumCaseAve;

  $: console.log();

  let chartWidth = 0;
  let chartHeight = 0;
  window.addEventListener("resize", function () {
    const chartContainer = document.getElementById("chartContainer");
    chartWidth = chartContainer.clientWidth;
    chartHeight = chartContainer.clientHeight;
  });

  const margin = { top: 20, right: 0, bottom: 15, left: 0 };

  const months = [
    "Jan",
    "Feb",
    "Mrz",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez",
  ];

  const formatDate = timeFormat("%d.%m.%Y");
  const formatMonth = timeFormat("%b");

  $: w = chartWidth - margin.right - margin.right;
  $: h = chartHeight - margin.top - margin.bottom;

  $: xScale = scaleLinear()
    .domain([0, cases.length])
    .range([margin.left, chartWidth - margin.right]);

  $: yScale = scaleLinear()
    .domain([0, data.max + 4000])
    .range([chartHeight - margin.bottom, margin.top]);

  $: yAxis = range(10e3, data.max, 10e3);

  $: line = d3line()
    .curve(curveBasis)
    .x((d, i) => xScale(i))
    .y((d) => yScale(d.a))(cases);
</script>

<div class="wrapper" role="img">
  {#if cases.length > 0}
    <div class="indicatorContainer">
      <!-- <div class="indicatorsRow">
        <div>
          <strong>{formatDate(new Date(data.updated))}</strong>
        </div>
      </div> -->
      <div class="indicatorRow">
        <div class="indicatorHeader">Bestätigte Fälle</div>
        <div class="indicatorBox">
          <div class="indicatorLabel dailyInfections">{data.lastNewCases}</div>
          <div class="indicatorAnnotation">
            {data.pctChangeCases}% zur Vorwoche
          </div>
        </div>
      </div>
      <div class="indicatorRow">
        <div class="indicatorHeader">Todesfälle</div>
        <div class="indicatorBox ">
          <div class="indicatorLabel dailyDeaths">{data.latestDeath}</div>
          <div class="indicatorAnnotation">
            {data.pctChangeDeath}% zur Vorwoche
          </div>
        </div>
      </div>
      {#if !isMobile}
        <div class="indicatorRow">
          <div class="indicatorHeader">Spitaleintritte</div>
          <div class="indicatorBox">
            <div class="indicatorLabel dailyHosp">{data.lastHosp}</div>
            <div class="indicatorAnnotation">
              {data.hospChange}% zur Vorwoche
            </div>
          </div>
        </div>
        <div class="indicatorRow">
          <div class="indicatorHeader">R-Wert</div>
          <div class="indicatorBox">
            <div class="indicatorLabel dailyR">{data.r}</div>
            <div class="indicatorAnnotation">
              Vertrauensintervall ±{data.rConfidence.toFixed(2)}
            </div>
          </div>
        </div>
      {/if}
      <div class="indicatorRow bottom desktop">
        <div class="meta">
          Stand: {formatDate(new Date(data.updated))} • Quellen: {isMobile
            ? `BAG, Kantone`
            : `BAG, Kantone`}
        </div>
      </div>
    </div>
    <div
      bind:clientWidth={chartWidth}
      bind:clientHeight={chartHeight}
      id="chartContainer"
      class="chartContainer"
    >
      <svg
        width={chartWidth}
        height={chartHeight}
        viewBox="0 0 {chartWidth}
        {chartHeight}"
      >
        {#each yAxis as yTick}
          <g transform="translate({xScale(0)},{yScale(yTick)})">
            <line x2={xScale(data.max)} class="gridline" />
            <text y={13} class="tick">{yTick}</text>
          </g>
        {/each}
        {#each cases as d, i}
          <rect
            x={xScale(i)}
            y={yScale(d.c)}
            width={Math.max(1, w / cases.length + 1)}
            height={Math.max(0, chartHeight - margin.bottom - yScale(d.c))}
          />
          {#if d.d.getDate() == 1 && d.d.getMonth() % 2 == 1}
            <g transform="translate({xScale(i)},{yScale(0)})">
              <line y2={6} class="gridline" />
              <text x={(15 * w) / cases.length} y={12} class="tick xAxisLabel">
                {months[d.d.getMonth()]}
              </text>
            </g>
          {/if}
        {/each}
        <path d={line} class="trendline" />
        <g
          transform="translate({xScale(cases.length)},{yScale(lastDatum.a) -
            33})"
        >
          <text class="valueLabelBg">7-Tage-Schnitt</text>
          <text class="valueLabel">7-Tage-Schnitt</text>
        </g>
        <g
          transform="translate({xScale(cases.length)},{yScale(lastDatum.a) -
            20})"
        >
          <text class="valueLabelBg">{lastAll7DSumCaseAve.toFixed(1)}</text>
          <text class="valueLabel">{lastAll7DSumCaseAve.toFixed(1)}</text>
        </g>
        <line
          class="gridline"
          x1={xScale(0)}
          x2={xScale(cases.length)}
          y1={yScale(0)}
          y2={yScale(0)}
        />
        <text y={12} class="title">Täglich bestätigte Fälle</text>
      </svg>
    </div>
  {:else}
    <div>Daten werden geladen…</div>
  {/if}
</div>

<style>
  /* layout */

  .wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    height: 100%;
    grid-gap: 28px;
  }

  .indicatorContainer {
    color: var(--text);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 28px;
    grid-row-gap: 7px;
  }

  .chartContainer {
    position: relative;
  }

  @media only screen and (max-width: 665px) {
    .wrapper {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 1.5fr;
      grid-row-gap: 14px;
    }
    .indicatorContainer {
      display: grid;
      grid-column-gap: 14px;
      grid-row-gap: 7px;
    }
  }

  /* indicators */

  .indicatorRow {
    align-self: top;
  }

  .bottom {
    align-self: end;
    grid-column-start: 1;
    grid-column-end: 3;
  }

  .indicatorHeader {
    font-weight: 700;
    margin-bottom: 15px;
    line-height: 0.9;
  }

  @media only screen and (max-width: 665px) {
    .indicatorHeader {
      margin-bottom: 7px;
    }
  }

  .indicatorBox {
    margin: auto;
  }

  .indicatorLabel {
    font-size: var(--large);
    font-weight: 700;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
  }

  .indicatorAnnotation {
    font-size: var(--small);
    line-height: 1.4;
    text-align: end;
  }

  .dailyInfections {
    background: #ffe462;
    color: #202346;
  }

  .dailyDeaths {
    background: #d3343f;
    color: #fff;
  }

  .dailyHosp {
    background: #76b7b6;
    color: #fff;
  }

  .dailyR {
    background: #e5cee3;
    color: #202346;
  }

  .meta {
    height: 15px;
    color: var(--grey);
    font-size: var(--small);
    display: flex;
    align-items: flex-end;
  }

  /* chart */

  svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  .title {
    font-weight: 700;
    fill: var(--text);
  }
  rect {
    fill: #ffe462;
  }
  .gridline {
    stroke: var(--grey);
    stroke-width: 1;
  }
  .tick {
    fill: var(--grey);
    font-size: var(--small);
  }
  .trendline {
    stroke: #e78d38;
    fill: none;
    stroke-width: 3px;
  }
  .xAxisLabel {
    text-anchor: middle;
  }
  .valueLabelBg {
    stroke: var(--bg);
    font-size: var(--small);
    stroke-width: 4px;
    text-anchor: end;
    font-weight: 400;
  }
  .valueLabel {
    fill: var(--text);
    font-size: var(--small);
    text-anchor: end;
    font-weight: 400;
    fill: #e78d38;
  }
</style>
